var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { axiosInstance } from '@/api/realApi/_axios';
import { joinUrl } from '@/api/realApi/_utils';
import { getCsrfHeaders } from '@/api/realApi/authApi';
const NOTES_URL_PATH = '/api/notes/';
const TAGS_URL_PATH = '/api/notes/tags/';
export const noteApi = {
    list: (params) => __awaiter(void 0, void 0, void 0, function* () {
        const res = yield axiosInstance.get(NOTES_URL_PATH, {
            params,
        });
        return res.data['results'] || res.data;
    }),
    get: (id) => __awaiter(void 0, void 0, void 0, function* () {
        const res = yield axiosInstance.get(joinUrl([NOTES_URL_PATH, id]));
        return res.data;
    }),
    create: (note) => __awaiter(void 0, void 0, void 0, function* () {
        const config = yield getCsrfHeaders();
        const res = yield axiosInstance.post(NOTES_URL_PATH, note, config);
        return res.data;
    }),
    update: (id, note) => __awaiter(void 0, void 0, void 0, function* () {
        const config = yield getCsrfHeaders();
        const res = yield axiosInstance.patch(joinUrl([NOTES_URL_PATH, id]), note, config);
        return res.data;
    }),
    delete: (id) => __awaiter(void 0, void 0, void 0, function* () {
        const config = yield getCsrfHeaders();
        yield axiosInstance.delete(joinUrl([NOTES_URL_PATH, id]), config);
    }),
    linkNote: (id, linkedNoteId) => __awaiter(void 0, void 0, void 0, function* () {
        const config = yield getCsrfHeaders();
        const res = yield axiosInstance.post(joinUrl([NOTES_URL_PATH, id, 'link']), { linked_note_id: linkedNoteId }, config);
        return res.data;
    }),
    unlinkNote: (id, linkedNoteId) => __awaiter(void 0, void 0, void 0, function* () {
        const config = yield getCsrfHeaders();
        const res = yield axiosInstance.post(joinUrl([NOTES_URL_PATH, id, 'unlink']), { linked_note_id: linkedNoteId }, config);
        return res.data;
    }),
};
export const tagApi = {
    list: (params) => __awaiter(void 0, void 0, void 0, function* () {
        const res = yield axiosInstance.get(TAGS_URL_PATH, {
            params,
        });
        return res.data['results'] || res.data;
    }),
    get: (id) => __awaiter(void 0, void 0, void 0, function* () {
        const res = yield axiosInstance.get(joinUrl([TAGS_URL_PATH, id]));
        return res.data;
    }),
    create: (tag) => __awaiter(void 0, void 0, void 0, function* () {
        const config = yield getCsrfHeaders();
        const res = yield axiosInstance.post(TAGS_URL_PATH, tag, config);
        return res.data;
    }),
    update: (id, tag) => __awaiter(void 0, void 0, void 0, function* () {
        const config = yield getCsrfHeaders();
        const res = yield axiosInstance.patch(joinUrl([TAGS_URL_PATH, id]), tag, config);
        return res.data;
    }),
    delete: (id) => __awaiter(void 0, void 0, void 0, function* () {
        const config = yield getCsrfHeaders();
        yield axiosInstance.delete(joinUrl([TAGS_URL_PATH, id]), config);
    }),
};
